// extracted by mini-css-extract-plugin
export var contentList = "grid-module--contentList--9a945";
export var five = "grid-module--five--fca6d";
export var footer = "grid-module--footer--64f13";
export var four = "grid-module--four--84fc3";
export var functionStyle = "grid-module--functionStyle--5389e";
export var gap_l = "grid-module--gap_l--f90e3";
export var gap_m = "grid-module--gap_m--8d622";
export var gap_s = "grid-module--gap_s--de316";
export var l = "grid-module--l--6882f";
export var m = "grid-module--m--60cf2";
export var root = "grid-module--root--1b334";
export var s = "grid-module--s--8d0a7";
export var three = "grid-module--three--075eb";
export var two = "grid-module--two--79629";